import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const DjiboutiFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14585'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14585)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V6.53333H0V14Z'
					fill='#1DC837'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 6.53333H20V0H0V6.53333Z'
					fill='#82C5F5'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0L9.52381 7L0 14V0Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.33408 7.90996L1.93459 8.88767L2.45095 7.28116L1.06966 6.27892L2.78828 6.26375L3.33408 4.66663L3.87988 6.26375L5.5985 6.27892L4.2172 7.28116L4.73357 8.88767L3.33408 7.90996Z'
					fill='#E21C21'
				/>
			</g>
		</svg>
	);
};

export default DjiboutiFlagIcon;
